<template>
    <div>
        <el-dialog title="" :visible.sync="detailsShow" :close-on-click-modal="false" width="70%" ref="dialog"
            @close="invoiceClose" top="5vh">
            <div>
                <div style="text-align: right">
                    <el-button type="primary" size="small" v-if="tag == 1" @click="receive()">确认收票</el-button>
                    <el-button type="danger" size="small" @click="refuse()" v-if="tag == 1">拒绝收票</el-button>
                    <el-button type="primary" size="small" v-if="tag == 2" @click="surePay()">确认支付</el-button>
                </div>
                <el-form :inline="true" label-width="140px" label-position="left" v-loading="loading">
                    <el-row>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px">
                                <h3 class="tk-head-title">申请信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="账号：" size="medium" class="item-width">
                                <div class="content-color">{{ info.applyAccount || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="账号Code：" size="medium" class="item-width">
                                <div class="content-color">{{ info.applyUserCode || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="申请人：" size="medium" class="item-width">
                                <div class="content-color">{{ info.applyUser || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="申请时间：" size="medium" class="item-width">
                                <div class="content-color">{{ info.applyDt || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px">
                                <h3 class="tk-head-title">发票信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票编号：" size="medium" class="item-width">
                                <div class="content-color">{{ info.invoiceNumber || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="应付金额：" size="medium" class="item-width">
                                <div class="content-color">{{ info.payableMoney || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票抬头类型：" size="medium" class="item-width">
                                <div class="content-color">
                                    {{ info.invoiceTitleType == 1?'企业':'个人' }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票类型：" size="medium" class="item-width">
                                <div class="content-color">{{ info.isVatInvoice?'增值税专用发票':'增值税普通发票' }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票抬头：" size="medium" class="item-width">
                                <div class="content-color">{{ info.invoiceTitle || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="纳税人识别号：" size="medium" class="item-width">
                                <div class="content-color">{{ info.taxNo || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="注册地址：" size="medium" class="item-width">
                                <div class="content-color">
                                    {{ info.companyAddress || "-" }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="注册号码：" size="medium" class="item-width">
                                <div class="content-color">{{ info.companyPhone || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开户银行：" size="medium" class="item-width">
                                <div class="content-color">{{ info.bankName || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="银行账号：" size="medium" class="item-width">
                                <div class="content-color">{{ info.bankNo || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开票内容：" size="medium" class="item-width">
                                <div class="content-color">
                                    {{ info.invoiceContent || "-" }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开票金额：" size="medium" class="item-width">
                                <div class="content-color">{{ info.invoiceMoney || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="开票税点：" size="medium" class="item-width">
                                <div class="content-color">{{ info.taxPoint || "-" }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :lg="12">
                            <el-form-item label="发票备注：" size="medium" class="item-width">
                                <div class="content-color">
                                    {{ info.invoiceRemarks || "-" }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <div class="tk-head-flex" style="margin-top: 10px">
                                <h3 class="tk-head-title">工单信息</h3>
                            </div>
                        </el-col>
                        <el-col :xs="24">
                            <el-table :data="tableData" border style="width: 100%">
                                <!-- <el-table-column prop="date" label="款项编号" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{scope.row.orderName || '--'}}</span>
                                    </template>
                                </el-table-column> -->
                                <el-table-column prop="name" label="工单号" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.orderNo || "--" }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="工单名称" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.orderName || "--" }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="发单方" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.senderName || "--" }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="应收金额" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.totalAmount || "--" }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="address" label="款项名称" width="180" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.orderName || "--" }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-col>
                    </el-row>
                </el-form>
                <br />
                <br />
            </div>
        </el-dialog>
        <el-dialog title="拒绝收票" :visible.sync="refusedInvoiceShow" :close-on-click-modal="false" width="600px"
            ref="dialog">
            <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入拒绝收票的原因" v-model.trim="textarea2">
            </el-input>
            <br />
            <br />
            <br />
            <div style="text-align: center">
                <el-button type="primary" size="medium" @click="refuseBtn()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {
        getStorageUserRoleId
    } from "@/utils/store";
    import {
        invoiceManagedetail_java,
        refuseTicket,
        confirmPayment,
        batchTicket,
    } from "@/service/payApi";

    export default {
        data() {
            return {
                detailsShow: false, //详情dialog
                refusedInvoiceShow: false, //拒绝收票dialog

                textarea2: "",

                tableData: [],
                tag: 1,
                info: {},
                id: "",
                loading:false,
            };
        },
        methods: {
            receive() {
                const _this = this
                this.$confirm("是否确认收票", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        var data = {
                            ids: this.id
                        };
                        _this.loading = true
                        batchTicket(data).then((r) => {
                            _this.loading = false
                            if (r.Result != 1) {
                                return this.$message.error(r.Message);
                            }
                            this.$message.success("收票成功");
                            this.detailsShow = false;
                            this.$parent.GetCouponsList()
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消收票",
                        });
                    });
            },
            surePay() {
                this.$confirm("是否确认支付", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        var data = {
                            id: this.id,
                            manageUserId: getStorageUserRoleId(),
                            platform: "zyd",
                        };
                        confirmPayment(data).then((r) => {
                            if (r.Result != 1) {
                                return this.$message.error(r.Message);
                            }
                            this.$message.success("支付成功");
                            this.detailsShow = false;
                            this.$parent.GetCouponsList()
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消支付",
                        });
                    });
            },
            refuseBtn() {
                const _this = this
                if (!this.textarea2) {
                    return this.$message.error("原因不能为空");
                }
                var data = {
                    id: this.id,
                    isGkInvoice: this.info.isVatInvoice,
                    manageUserId: getStorageUserRoleId(),
                    platform: "zyd",
                    refuseReason: this.textarea2,
                };
                _this.loading = true
                refuseTicket(data).then((r) => {
                    _this.loading = false
                    if (r.Result != 1) {
                        return this.$message.error(r.Message);
                    }
                    this.$message.success("拒绝收票成功");
                    this.textarea2 = ""
                    this.refusedInvoiceShow = false;
                    this.detailsShow = false;
                    this.$parent.GetCouponsList();
                });
            },
            refuse() {
                this.refusedInvoiceShow = true;
            },
            open(row, tag) {
                this.loading = true;
                this.tag = tag;
                this.id = row.id;
                var data = {
                    id: row.id,
                    platform: "zyd",
                    manageUserId: getStorageUserRoleId(),
                };
                invoiceManagedetail_java(data).then((r) => {
                    this.loading = false;
                    if (r.Result != 1) {
                        return this.$message.error(r.Message);
                    }
                    this.detailsShow = true;
                    this.info = r.Data;
                    this.tableData = r.Data.workOrderInfRVO;
                });
            },
            invoiceClose() {
                this.detailsShow = false;
            },
        },
    };
</script>
<style lang="scss">
    .tk-head-flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .tk-head-title {
            font-size: 20px;
            font-weight: bold;
            color: #333333;
        }
    }

    .item-width {
        width: 100%;

        .el-form-item__content {
            width: calc(100% - 200px);
        }
    }

    .content-color {
        font-size: 16px;
        color: #333333;
    }
</style>